export default "__VITE_ASSET__B1n9N7E$__"